/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CygniDeviceBatteryStatsResponse } from '../models/cygni-device-battery-stats-response';
import { DeviceStatsParamsDto } from '../models/device-stats-params-dto';

@Injectable({
  providedIn: 'root',
})
export class CygniDeviceMetricsControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getBatteryStats
   */
  static readonly GetBatteryStatsPath = '/api/v1/cygni/device/{deviceId}/battery-stats';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBatteryStats()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getBatteryStats$Response(params: {
    deviceId: string;
    body?: DeviceStatsParamsDto
  }): Observable<StrictHttpResponse<CygniDeviceBatteryStatsResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CygniDeviceMetricsControllerService.GetBatteryStatsPath, 'post');
    if (params) {
      rb.path('deviceId', params.deviceId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CygniDeviceBatteryStatsResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getBatteryStats$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getBatteryStats(params: {
    deviceId: string;
    body?: DeviceStatsParamsDto
  }): Observable<CygniDeviceBatteryStatsResponse> {

    return this.getBatteryStats$Response(params).pipe(
      map((r: StrictHttpResponse<CygniDeviceBatteryStatsResponse>) => r.body as CygniDeviceBatteryStatsResponse)
    );
  }

}
